<template>
  <section class="app-container">
    <GovBanner />
    <mobile-menu />
    <StandardHeader />
    <nuxt />
    <Footer />
  </section>
</template>

<script>
import StandardHeader from "~/components/StandardHeader/StandardHeader.vue";
import Footer from "~/components/Footer/Footer.vue";
import MobileMenu from "~/components/MobileMenu/MobileMenu";
import GovBanner from "~/components/GovBanner/GovBanner.vue";

function gtag() {
  window.dataLayer.push(arguments);
}
if (process.client) {
  window.dataLayer = window.dataLayer || [];
  gtag("js", new Date());
  gtag("config", "G-1Y62SDLGRS", { "debug_mode":true });
}

export default {
  components: {
    GovBanner,
    StandardHeader,
    Footer,
    MobileMenu,
  },
};
</script>

<style lang="scss">
.app-container {
  @include app-container;
}
</style>
